import { useI18n } from "vue-i18n";

export { default as Action } from "./Action.vue";
export { default as ActionList } from "./ActionList.vue";
export { default as ActionsButton } from "./ActionsButton.vue";
export { default as ActionsModal } from "./ActionsModal.vue";
export { default as BulkActionsBar } from "./BulkActionsBar.vue";
export { default as DeleteButton } from "./DeleteButton.vue";
export { default as Selected } from "./Selected.vue";
export { default as TaskPrimaryActionButton } from "./TaskPrimaryActionButton.vue";

import { FilterType as ActionType } from "@/SharedComponents/Filters";
export { ActionType };

export function useActions() {
    const { t } = useI18n();

    const actions = Object.freeze({
        [ActionType.DUE_DATE]: {
            id: ActionType.DUE_DATE,
            label: getActionLabel(ActionType.DUE_DATE),
            icon: "calendar-default",
        },
        [ActionType.EXPIRATION_DATE]: {
            id: ActionType.EXPIRATION_DATE,
            label: getActionLabel(ActionType.EXPIRATION_DATE),
            icon: "stopwatch",
        },
        [ActionType.NOTIFICATION_DATE]: {
            id: ActionType.NOTIFICATION_DATE,
            label: getActionLabel(ActionType.NOTIFICATION_DATE),
            icon: "bell-default",
        },
        [ActionType.PRIORITY]: {
            id: ActionType.PRIORITY,
            label: getActionLabel(ActionType.PRIORITY),
            icon: "error-circle",
        },
        [ActionType.CATEGORY]: {
            id: ActionType.CATEGORY,
            label: getActionLabel(ActionType.CATEGORY),
            icon: "view-grid",
        },
        [ActionType.ASSIGNED_TO]: {
            id: ActionType.ASSIGNED_TO,
            label: getActionLabel(ActionType.ASSIGNED_TO),
            icon: "users-default",
        },
        [ActionType.TAGS]: {
            id: ActionType.TAGS,
            label: getActionLabel(ActionType.TAGS),
            icon: "tag",
        },
        [ActionType.VISIBILITY]: {
            id: ActionType.VISIBILITY,
            label: getActionLabel(ActionType.VISIBILITY),
            icon: "eye-visible",
        },
        [ActionType.ASSET_GROUPS]: {
            id: ActionType.ASSET_GROUPS,
            label: getActionLabel(ActionType.ASSET_GROUPS),
            icon: "folder-open",
        },
    });

    function getActionLabel(actionType) {
        switch (actionType) {
            case ActionType.DUE_DATE:
                return t("components.filters.due_date.label");
            case ActionType.EXPIRATION_DATE:
                return t("components.filters.expiration_date.label");
            case ActionType.NOTIFICATION_DATE:
                return t("components.filters.notification_date.label");
            case ActionType.PRIORITY:
                return t("components.filters.priority.label");
            case ActionType.CATEGORY:
                return t("components.filters.category.label");
            case ActionType.ASSIGNED_TO:
                return t("components.filters.assigned_to.label");
            case ActionType.TAGS:
                return t("components.filters.tags.label");
            case ActionType.VISIBILITY:
                return t("components.filters.visibility.label");
            case ActionType.ASSET_GROUPS:
                return t("components.properties.group");
            default:
                return "";
        }
    }

    function getActionTitle(actionType) {
        return t("components.bulk_actions.change", {
            property: getActionLabel(actionType),
        });
    }

    return {
        actions,
        getActionLabel,
        getActionTitle,
    };
}
